import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["alt"]
const _hoisted_2 = ["src"]

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleImage',
  props: {
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: '',
  },
  threshold: {
    type: Number,
    default: 0.1,
    required: false
  },
},
  emits: ['load'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const basePath = (process.env.BASE_URL === './' ? '/' : process.env.BASE_URL) + 'images';
const fileName = computed(() => {
  // return props.src.split('.')[0].split('img/')[1];
  return props.src.split('.')[0];
});

const srcWebp = `${basePath}/webp/${fileName.value}.webp`;
const srcAvif = `${basePath}/avif/${fileName.value}.avif`;


const onLoad = () => {
  emit('load');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("picture", { alt: __props.alt }, [
    srcAvif
      ? (_openBlock(), _createElementBlock("source", {
          key: 0,
          srcset: srcAvif,
          type: "image/avif"
        }))
      : _createCommentVNode("", true),
    srcWebp
      ? (_openBlock(), _createElementBlock("source", {
          key: 1,
          srcset: srcWebp,
          type: "image/webp"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: require(`@/assets/images/${__props.src}`),
      onLoad: onLoad
    }, null, 40, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})